export default {
  Period: 'Kỳ lập',
  Year: 'Năm',
  GetData: 'Lấy dữ liệu',
  GenerateVoucherShort: 'Sinh chứng từ',
  GenerateVoucher: 'Sinh chứng từ (Ctrl + S)',
  GetVoucherSalaGov: 'Lấy chứng từ chi trả lương SalaGov',
  WithdrawalForm: 'Hình thức rút',
  Deposit: 'Rút dự toán tiền gửi',
  Cash: 'Rút dự toán tiền mặt',
  Transfer: 'Rút dự toán chuyển khoản',
  VoucherName: 'Chi tiết chứng từ {0}',
  Message: {
    NoData: 'Danh sách chứng từ chi trả lương, bảo hiểm kỳ lập tháng {0} trống. Vui lòng kiểm tra lại trên SalaGov.',
    NoDataTitle: 'Không có dữ liệu',
    RequiredLeastOne: 'Bạn cần chọn ít nhất một chứng từ từ SalaGov.'
  }
};
